export function authRedirect(url: string): void {
    const authRoute = (url === 'signin') || (url === 'bookingsignin') ?
        'signin?cb=' + encodeURIComponent(location.pathname) :
        url;
    const $injector = angular.element(document).injector();
    const $rootScope = $injector.get('$rootScope');
    $injector.get('$location').url(authRoute);
    if (!$rootScope.$$phase) {
        $rootScope.$apply();
    }
}
